import { List } from 'antd';
import styled from 'styled-components';

import { Button, Collapse } from 'components/ui';

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:hover {
    button {
      visibility: visible;
      opacity: 1;
    }
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  .anticon {
    display: flex;
    height: 1rem;
    width: 1rem;
    margin-right: 0.5rem;

    svg {
      height: 1 rem;
      width: 1rem;
    }
  }

  span:not(.blade-card-name) {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 360px;
  }
`;

export const StyledButton = styled(Button)`
  visibility: hidden;
  opacity: 0;
  border: none;
  box-shadow: none;
  height: 1.25rem;
  width: 1.25rem;
  background: transparent;
  padding: 0;

  &:hover,
  &:focus,
  &:active {
    background: transparent;
  }

  .anticon {
    display: flex;
    color: inherit;
  }

  svg {
    height: 1.25rem;
    width: 1.25rem;
  }
`;

export const StyledCollapse = styled(Collapse)`
  .ant-collapse-content {
    overflow-y: auto;
    max-height: 50vh;
  }
`;

export const StyledListContainer = styled.div`
  .ant-list + .ant-list {
    margin-top: 1em;
  }
`;

export const StyledList = styled(List)`
  .ant-list-header {
    color: ${({ theme }) => theme.headerColor};
    font-weight: bold;
    border: none !important;
    padding: 0 !important;
    margin-bottom: 0.25em;
  }
`;

export const StyledListItem = styled(List.Item)`
  border: none !important;
  padding: 0 !important;

  ul {
    list-style: disc;
    padding-left: 2em;
  }
`;

export const StyledFilterList = styled(StyledList)`
  ${StyledListItem} + ${StyledListItem} {
    margin-top: 0.5rem;
  }
`;

export const StyledSortList = styled(StyledList)`
  ${StyledListItem} + ${StyledListItem} {
    margin-top: 0.25rem;
  }
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.labelColor};
  font-weight: 700;
  margin-right: 8px;
`;

export const Description = styled.span`
  color: ${({ theme }) => theme.descriptionColor};
  font-weight: 400;

  > div {
    padding-left: 16px;
  }

  > div + div {
    margin-top: 2px;
  }
`;

export const StyledOperator = styled.span`
  color: ${({ theme }) => theme.secondaryTextColor};
  margin-right: 8px;
  font-style: italic;
`;
